export const headerHeight = 100;
export const footerHeight = 306;

// base colors
export const alto = '#dadada';
export const black = '#000000';
export const carmine = '#990433';
export const red = '#f00';
export const dimGray = '#676767';
export const gainsboro = '#dbe3e3';
export const orange = '#f69f0c';
export const buttercup = '#f6a00c';
export const orangered = '#ec5700';
export const silverChalice = '#a7a7a7';
export const slateblue = '#697dc6';
export const steelblue = '#257bba';
export const trinidad = '#ec5800';
export const white = '#ffffff';
export const whiteSmoke = '#f4f4f4';
export const iron = '#d7d8d8';
export const blackHaze = '#eaecec';
export const mediumCarmine = '#b73432';
export const orangePeel = '#faa100';
export const lightningYellow = '#fcc71f';
export const silverSand = '#b4bdbd';
export const cobalt = '#0056b3';
export const lightCobalt = '#296fce';
export const solitude = '#e5e8ed';
export const blueMagenta = '#6d6d7b';
export const gunPowder = '#4a4a56';
export const doveGray = '#666666';

// components colors
export const headerBorderColor = gainsboro;
export const headerBackground = white;
export const headerLinkColor = white;
export const headerActionButtonColor = black;
export const primaryBackgroundButtonColor = orangered;
export const primaryTextButtonColor = white;
export const secondaryBackgroundButtonColor = gainsboro;
export const secondaryTextButtonColor = black;
export const userEntryBackground = whiteSmoke;
export const userLinkBackground = orange;
export const badgeShoppingCartBackground = trinidad;
export const badgeShoppingCartColor = whiteSmoke;
export const loaderBackground = whiteSmoke;
export const loaderForeground = alto;
export const checkboxColor = slateblue;
export const mainBackground = blackHaze;
export const footerBackgroundColor = solitude;
export const footerLinkColor = '#6d6d7b';
export const footerLinkHeaderColor = gunPowder;
export const footerDividerColor = '#c2c2c2';
export const footerCopyrightTextColor = '#999999';
